import { ClientSearchSchema } from '@/features/dashboard/client/clientSchema';
import { ClientList } from '@/features/dashboard/client/list/ClientList'
import { usePageTitle } from '@/hooks/usePageTitle';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/clients/')({
  component: RouteComponent,
  validateSearch: ClientSearchSchema
})

function RouteComponent() {
  usePageTitle("顧客一覧");
  return <ClientList />
}
